<template>
	<div class="account-info widget coverage_info">
		<div v-for="( policy, index ) in policies" :key="index">
			<h3 v-if="policy.policy_number">Policy Number</h3>
			<span class="policy_number" v-if="policy.policy_number">{{ policy.policy_number }}</span>
			<h3 v-if="policy.policy_effective_start && policy.policy_effective_end">Coverage Dates</h3>
			<span class="coverage_dates" v-if="policy.policy_effective_start && policy.policy_effective_end">
				{{ policy.policy_effective_start | moment( 'MM/D/YYYY' ) }} - {{ policy.policy_effective_end | moment( 'MM/D/YYYY' ) }}
			</span>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "InsureCarePolicyInfo",
  computed: {
    ...mapGetters( 'Policy', [ 'policies'] )
  }
};
</script>

<style lang="scss" scoped>
.account-info {
	h3 {
		font-weight: 600;
	}

	span {
		font-weight: bold !important;
	}

	> div {
		border-bottom: 1px solid #005E86;
		padding-bottom: 10px;
		margin-bottom: 10px;

		&:last-of-type {
			border-bottom: 0px;
			padding-bottom: 0px;
			margin-bottom: 0px;
		}
	}
}
</style>

